import React from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from 'component/Layout/Form/Checkbox';

import classNames from 'classnames';

import { useHotelTransferAtom } from 'hooks/form/filter';
import { useTransferMeta } from 'hooks/form/meta';
import { useChangedFilterList } from 'hooks/form/useChangedFilterList';

import { SearchParam } from 'types/Search/params';

import styles from '../../Filter.module.scss';
import FilterLabel from '../../Segment/FilterLabel';

const HotelTransfer = () => {
    const [hotelTransfer, setHotelTransfer] = useHotelTransferAtom();
    const [transferMeta] = useTransferMeta();
    const { onToggle, isFilterChanged } = useChangedFilterList();

    const { t } = useTranslation();
    const label = t('TRANS-hotel-transfer');

    return {
        isSelected: hotelTransfer,
        filterValue: label,
        content: (
            <Checkbox
                key={SearchParam.HotelTransfer}
                input={{
                    id: SearchParam.HotelTransfer,
                    name: SearchParam.HotelTransfer,
                    value: SearchParam.HotelTransfer,
                }}
                isChecked={hotelTransfer}
                onChange={() => {
                    onToggle(SearchParam.HotelTransfer);
                    setHotelTransfer((current) => !current);
                }}
                withUXSelection
                customClass={{
                    Wrapper: classNames({
                        [styles.Changed]: isFilterChanged(
                            SearchParam.HotelTransfer
                        ),
                    }),
                }}
            >
                <FilterLabel
                    labelText={label}
                    tooltip={t('TRANS-transfer-tooltip-included')}
                    {...transferMeta?.hotelTransfer}
                />
            </Checkbox>
        ),
        kiFilterData: {
            label,
            isSelectable: true,
            urlKey: SearchParam.HotelTransfer,
            value: SearchParam.HotelTransfer ?? '',
            ...transferMeta?.hotelTransfer,
        },
    };
};

export default HotelTransfer;
